import styled from 'styled-components';

const AccordionIcon = styled.span`
    padding: 0;
    border: none;
    background: none;
    &::before {
        content: '';
        background-image: url(${props => (props.open ? '/assets/accordionclose.svg' : '/assets/accordionadd.svg')});
        height: 1.25rem;
        width: 1.25rem;
        display: block;
        left: 0;
        top: 0;
    }
    &.expand {
        &::before {
            content: '';
            background-image: url(${props => (props.open ? '/assets/accordionclose.svg' : '/assets/accordionadd.svg')});
        }
    }
`;

export default AccordionIcon;
